import {
  dimensiondata_1_keszletek_group_row,
  dimensiondata_2_tetelek_group_dimension_1_column,
  ezer_kobmeter_value_1_data_no_year_month_summary,
  megawatt_ora_value_2_data_no_year_month_summary,
  year_row_expanded,
  month_row_expanded,
  day_row,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const gazElozetesNapiMerlegConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/GazElozetesNapiMerleg',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1', 'value_2'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      year_row_expanded,
      month_row_expanded,
      day_row,
      ...dimensiondata_1_keszletek_group_row,
      ...dimensiondata_2_tetelek_group_dimension_1_column,
      ezer_kobmeter_value_1_data_no_year_month_summary,
      megawatt_ora_value_2_data_no_year_month_summary,
      order_1,
      order_2
    ],
  },
};
